import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const items = [
  { label: 'Warning', value: 'warning' },
  { label: 'Critical', value: 'critical' },
  { label: 'Fatal', value: 'fatal' },
]

interface Props {}

export default function SeverityPicklist(props: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown name="severity" label="Severity" compact showAll items={items} {...props} />
}
